export type SupportedGroups = "recents" | "similar" | "searchResults";
export type GroupsRenderOrder = Array<SupportedGroups>;

const defaultGroupsRenderOrder = ["recents", "searchResults", "similar"] satisfies GroupsRenderOrder;

export const getOrderedGroupNames = (groupsRenderOrder?: GroupsRenderOrder) => {
    const defaultGroupsOrder = [...defaultGroupsRenderOrder];

    if (!groupsRenderOrder) {
        return defaultGroupsOrder;
    }

    const getGroupsRenderOrderIndex = (groupName: SupportedGroups) => {
        const index = groupsRenderOrder.indexOf(groupName);

        return index === -1 ? Infinity : index;
    };

    return defaultGroupsOrder.sort((a, b) => getGroupsRenderOrderIndex(a) - getGroupsRenderOrderIndex(b));
};
